/**
 * KPI-ul zilei: `Disponibil` / `De plata` / `Blocat TVA`. Cifra e mare, tabulara si insotita de
 * provenienta — `Disponibil` din headerul zilei duce in `/cashflow`, exact ca sa inlocuiasca
 * formula `=Cashflow!C3+Cashflow!C4` cu un link pe care poti apasa.
 */

import type { ReactNode } from 'react';
import { Money } from './Money.tsx';

export interface PropsStatTile {
  eticheta: string;
  minor: number | null;
  moneda?: string;
  /** Din ce e compusa cifra (inlocuieste formula ascunsa din Excel). */
  detaliu?: ReactNode;
  /** Link de provenienta sau actiune scurta. */
  actiune?: ReactNode;
  creditLine?: boolean;
  className?: string;
}

export function StatTile({
  eticheta,
  minor,
  moneda = 'lei',
  detaliu,
  actiune,
  creditLine = false,
  className,
}: PropsStatTile) {
  return (
    <div className={`tile ${className ?? ''}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-11 font-medium tracking-wide text-ink-2 uppercase">{eticheta}</span>
        {actiune}
      </div>

      <Money
        minor={minor}
        moneda={moneda}
        creditLine={creditLine}
        className="text-20 leading-tight"
      />

      {detaliu ? <div className="text-11 text-ink-3">{detaliu}</div> : null}
    </div>
  );
}
